// Accès admin / mode prévisualisation (QA interne).
//
// La qualité d'admin est désormais définie EN BASE (colonne profiles.is_admin,
// pilotable depuis Supabase), plus dans une liste hardcodée. Elle débloque :
//  - l'ouverture de TOUS les jours de quiz/missions (hooks/useQuiz.ts) ;
//  - la validation des actions/quiz hors du jour courant (RPC serveur) ;
//  - l'affichage de l'onboarding à chaque connexion (index/login) et la
//    simulation de la semaine du concours (_layout).
//
// Les écritures sensibles (points, dates) restent verrouillées côté serveur
// par les triggers/RPC d'intégrité : le mode admin ne fait que *prévisualiser*
// et lever la restriction de date (contrôlée serveur via current_user_is_admin()).

import { supabase } from "@/utils/supabase";

/**
 * L'utilisateur (par son id) est-il admin ? Source unique : profiles.is_admin.
 * Retourne false en cas d'absence de session, d'erreur ou de profil manquant.
 * Pour les composants sous ProfileProvider, préférer `useProfile().isAdmin`.
 */
export async function fetchIsAdmin(userId?: string | null): Promise<boolean> {
  if (!userId) return false;
  try {
    const { data, error } = await supabase
      .from("profiles")
      .select("is_admin")
      .eq("id", userId)
      .maybeSingle();
    if (error) return false;
    return data?.is_admin === true;
  } catch {
    return false;
  }
}
